import { render } from "./node.vue?vue&type=template&id=48bb691d&scoped=true"
import script from "./node.vue?vue&type=script&lang=js"
export * from "./node.vue?vue&type=script&lang=js"

import "./node.vue?vue&type=style&index=0&id=48bb691d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48bb691d"]])

export default __exports__